import React from 'react';
import { Printer, Trash2 } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from '../ui/alert-dialog';

const usd = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const DeleteTestCheck = ({ c, onDelete }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button data-testid={`tc-delete-${c.check_id}`} className="ml-3 inline-flex items-center gap-1 text-red-400 text-xs hover:text-red-300"><Trash2 className="w-3 h-3" /> Delete</button>
    </AlertDialogTrigger>
    <AlertDialogContent className="bg-slate-800 border-slate-700 text-white">
      <AlertDialogHeader>
        <AlertDialogTitle>Delete test check No. {c.check_no ?? '-'}?</AlertDialogTitle>
        <AlertDialogDescription className="text-slate-400">This Sepolia test check ({usd(c.amount)}) is removed from your lists. An audit copy is kept. The Sepolia test tokens are not affected.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="bg-slate-700 border-slate-600 text-white" data-testid="tc-delete-cancel">Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={() => onDelete(c)} className="bg-red-600 hover:bg-red-700" data-testid="tc-delete-confirm">Delete</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const IssuedChecksList = ({ checks, printPath, testid = 'tc-issued-checks', onDelete }) => (
  <div className="bg-slate-800 border border-slate-700 rounded-xl p-5 overflow-x-auto" data-testid={testid}>
    <h3 className="text-white font-semibold mb-2">Issued Treasury Checks</h3>
    <table className="w-full text-sm"><tbody className="divide-y divide-slate-700">
      {checks.map(c => (
        <tr key={c.check_id} className="text-slate-300" data-testid={`tc-check-row-${c.check_no}`}>
          <td className="py-1.5 pr-3 text-white">No. {c.check_no ?? '-'}</td>
          <td className="py-1.5 pr-3">{usd(c.amount)}</td>
          <td className="py-1.5 pr-3 text-xs">{c.payee?.name || c.payee_address}</td>
          <td className="py-1.5 pr-3 text-xs">CUSIP {c.reference?.cusip}</td>
          <td className="py-1.5 pr-3 text-xs text-slate-500">{c.created_at.slice(0, 10)} · {c.network === 'base' ? 'Base' : c.network}
            {c.network === 'sepolia' && <span className="ml-2 px-1.5 py-0.5 rounded bg-red-500/15 text-red-300 text-[10px] font-semibold" data-testid={`tc-test-badge-${c.check_id}`}>TEST</span>}</td>
          <td className="py-1.5 text-right whitespace-nowrap">
            <a href={printPath(c.check_id)} data-testid={`tc-print-${c.check_no}`} className="inline-flex items-center gap-1 text-emerald-400 text-xs underline"><Printer className="w-3 h-3" /> Check &amp; voucher</a>
            {onDelete && c.network === 'sepolia' && <DeleteTestCheck c={c} onDelete={onDelete} />}
          </td>
        </tr>
      ))}
      {!checks.length && <tr><td className="py-3 text-slate-500">No checks issued yet</td></tr>}
    </tbody></table>
  </div>
);
